// Commenting out telemetry for now, it causes issues - will address in separate task
// import React from 'react';
// import { MentoringModuleReactContext } from '@careerhub/mentoring';
import { EnvironmentType } from '@careerhub/common/dist/resources/environmentTypes';
import campaignDefinitions from './CampaignDefinitions';
import { TelemetrySinkProvider } from './logging/TelemetrySinkProvider';

export const CaptureMultiFeedback = () => {
  // const { telemetryClient } = React.useContext(MentoringModuleReactContext);
  // telemetryClient log button click

  // This launches a Multiple feedback window
  try {
    (window as any).OfficeBrowserFeedback.multiFeedback();
  } catch (ex) {
    // TODO:  Telemetry client log error
    console.log(`Error trying to call multiFeedback: ${ex}`);
  }
};

export const OcvInit = async (ref?: React.RefObject<HTMLButtonElement>) => {
  // const { telemetryClient } = React.useContext(MentoringModuleReactContext);

  const triggerSurveyActivity = () => {
    (<any>window).OfficeBrowserFeedback.floodgate
      .getEngine()
      .getActivityListener()
      .logActivity('SurveyActivityTriggered');
  };

  const sinkClient = new TelemetrySinkProvider();
  //Reference the class structure in "node_modules\@ms-ofb\officebrowserfeedback\typings\OfficeBrowserFeedback.d.ts"
  (<any>window).OfficeBrowserFeedback = (<any>window).OfficeBrowserFeedback || {};
  (<any>window).OfficeBrowserFeedback.floodgate = (<any>window).OfficeBrowserFeedback.floodgate || {};
  (<any>window).OfficeBrowserFeedback.initOptions = {
    appId: __OCV__,
    stylesUrl: '/styles/feedback.styles.css',
    intlUrl: '/scripts/intl/',
    environment: __ENVIRONMENT__ === EnvironmentType.Production ? 0 : 1, // 1 is for test and 0 is for Production
    primaryColour: '#535593',
    secondaryColour: '#6264A7',
    onError: function onError(err: any) {
      // TODO:  telemetry client log error
      console.log('Office InAppFeedback SDK encountered error.', { err });
    },
    onDismiss: function (success: boolean) {
      ref && ref.current?.focus();
      if (success) {
        // TODO: telemetryClient Log info and Log feedback submitted event
        // can we capture which feedback (like, don't like, suggestion?)
        console.log('Successfully captured feedback using Office Customer Voice InAppFeedback.', {});
        console.log('UserInAppFeedback', {});
      } else {
        // TODO:  telemetryClient log feedback cancelled event
        console.log('OnDimiss: !success');
      }
    },
    telemetrySink: sinkClient.getTelemetrySink(),
  };

  // ************************
  // floodgate initialization
  //console.log(`Survey: ${campaignDefinitions[0].CampaignId}`);
  (<any>window).OfficeBrowserFeedback.floodgate.initOptions = {
    autoDismiss: __IS_E2E_TESTING__ ? 1 : 0,
    campaignDefinitions: campaignDefinitions,
  };

  var waitTime = 0;
  if (!!(<any>window).OfficeBrowserFeedback.floodgate.initialize) {
    console.log('initialize not loaded, delaying');
    waitTime = 500;
  }

  window.setTimeout(async () => {
    await (<any>window).OfficeBrowserFeedback.floodgate.initialize();
    console.log('successfully initialized');
    await (<any>window).OfficeBrowserFeedback.floodgate.start();
    triggerSurveyActivity();
  }, waitTime);

  (<any>window).onclick = () => {
    if ((<any>window).OfficeBrowserFeedback.floodgate) {
      (<any>window).OfficeBrowserFeedback.floodgate.start();
      triggerSurveyActivity();
    }
    // telemetryClient.logButtonClick(FeatureName.Feedback, SubFeatureName.SystemInitiatedFeedback);
  };

  (<any>window).onblur = () => {
    if ((<any>window).OfficeBrowserFeedback.floodgate) {
      (<any>window).OfficeBrowserFeedback.floodgate.stop();
    }
  };

  (<any>window).onunload = () => {
    if ((<any>window).OfficeBrowserFeedback.floodgate) {
      (<any>window).OfficeBrowserFeedback.floodgate.stop();
    }
  };

  // TODO:  telemetryGroup - featurearea / subarea
};
